// @ts-check
import { state as _state, getDefaultState } from './state';
import { saveState } from './internals/helpers';
import { resetMessageStore } from './internals/message.store';
import { checkFreebet } from './internals/freebet';
import BookBetslipRequestService from '@bto-services/api/shared/reservation-code/book-betslip.request';
import { calculateBonuses, calculateSingleBonus } from './internals/calculations';
import { BETSLIP_ACCEPT_ODD_TYPE } from 'bto-models/betslip';

/**
 * Services
 */
export * from './internals/tabs';
export * from './internals/stake';
export * from './internals/items';
export * from './internals/folds';
export * from './internals/helpers';
export * from './internals/place';
export * from './internals/placement-validations';
export * from './internals/betslip-search';
export * from './internals/freebet';
export * from './internals/quickbet';
export * from './internals/races';
export * from './internals/algo';
export { getCombsDetails, calculateBonuses } from './internals/calculations';
/**
 * Stores
 */
export * from './internals/config.store';
export * from './internals/message.store';
export * from './internals/special-bet-comb.store';
export * from './internals/freebet.store';
export * from './internals/assisted-user.store';
export * from './internals/simulate.store';
/**
 * Get the toggled enum value for accept changed odds
 */
function getToggleAcceptOdds() {
	if (betslipStore.acceptOddChange === BETSLIP_ACCEPT_ODD_TYPE.ALL) {
		return BETSLIP_ACCEPT_ODD_TYPE.NO;
	}
	return BETSLIP_ACCEPT_ODD_TYPE.ALL;
}

/**
 * Change accept odds flag
 * @param {import('bto-models/betslip/interfaces').BETSLIP_ACCEPT_ODD_TYPE_ENUMS} num - Enum for accept odd changes
 */
export const changeAcceptOdds = (num) => {
	if (!num) {
		betslipStore.acceptOddChange = getToggleAcceptOdds();
	} else {
		betslipStore.acceptOddChange = num;
	}

	saveState();
};

/**
 * Change accept odds flag
 */
export const changeManualAuth = () => {
	betslipStore.manualAuth = !betslipStore.manualAuth;
	saveState();
};

/**
 * Set note on betslip
 * @param {string} note - Note to save
 */
export const setNote = (note) => {
	betslipStore.note = note;
	saveState();
}

/**
 * Change show bankers flag
 */
export const changeShowBankers = () => {
	betslipStore.showBankers = !betslipStore.showBankers;
	saveState();
};

/**
 * Reset betslip to base state
 */
export const clearBetslip = () => {
	const keepState = {
		// showBankers: state.showBankers,
	};
	/**
	 * When quickbet is active keep the following state during clear
	 * so we don't have to add them on every single quickbet bet place
	 */
	if (betslipStore.quickBetActive) {
		keepState.quickBetActive = betslipStore.quickBetActive;
		keepState.quickBetStake = betslipStore.quickBetStake;
		keepState.acceptOddChange = betslipStore.acceptOddChange;
	}
	Object.assign(betslipStore, getDefaultState(), keepState);
	resetMessageStore();
	saveState();
};

/**
 * Check if rebeted betslip was extracted during place, if it was recalculate bonuses
 * @param {import('bto-models/betslip').BetslipStore} newBetslip 
 */
function extractedSingleRebet(newBetslip) {
	if (newBetslip.extractedSingleItem) {
		const itemKey = Object.keys(newBetslip.items)[0];
		calculateSingleBonus(itemKey);
		calculateBonuses();
		delete betslipStore.extractedSingleItem;
	}
}

/**
 * Load saved betslip into betslip store
 * @param {import('bto-models/betslip').BetslipStore} newBetslip
 * @param {string} [code] - optional booking code
 */
export const rebet = (newBetslip, code = null) => {
	if (code) {
		newBetslip.bookedBetslipDetails.bookCode = code;
		newBetslip.bookedBetslipDetails.matchItems = Object.keys(newBetslip.matchItems);
	}
	Object.assign(betslipStore, newBetslip);
	extractedSingleRebet(newBetslip);
	checkFreebet();
	resetMessageStore();
	saveState();
};

/**
 * Book betslip
 */
export const bookBetslip = () => {
	const bookBetslipRequestService = new BookBetslipRequestService(betslipStore);
	return bookBetslipRequestService.execute();
};

export const betslipStore = _state;
